"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var link_1 = require("spry-react/Link/link");
require("./siteHeader.less");
var SiteHeader = /** @class */ (function (_super) {
    __extends(SiteHeader, _super);
    function SiteHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteHeader.prototype.render = function () {
        var borderedClass = this.props.bordered ? "border border-left border-bottom" : "";
        return React.createElement("section", { id: "site-header", className: "clearfix" },
            React.createElement("div", { className: "site-sidebar-column logo border border-bottom" },
                React.createElement(link_1.Link, { id: "site-branding-logo", className: "site-branding-logo-img-container", url: this.props.homeUrl },
                    React.createElement("img", { className: "site-branding-logo-img", src: this.props.logoImageUrl, alt: "Site Logo" }))),
            React.createElement("div", { id: "site-header-right", className: "site-main-column " + borderedClass }, this.props.children),
            React.createElement("div", { id: "flash-notification-container", "aria-live": "assertive" }));
    };
    return SiteHeader;
}(React.PureComponent));
exports.SiteHeader = SiteHeader;
